import { useNavigate } from 'react-router-dom';

const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;
const PHONE_URL = `tel:${WHATSAPP_NUMBER}`;

const logoUrl = 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/b98f8b06412a69b29f2607cb4b17b272.png';

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Projects', path: '/projects' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const projectLinks = [
  { label: 'Ministry of Commerce Housing', path: '/projects/ministry-commerce-housing' },
  { label: 'Blue World City', path: '/projects/blue-world-city' },
  { label: 'Park View City', path: '/projects/park-view-city' },
  { label: 'Capital Smart City', path: '/projects/capital-smart-city' },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-charcoal-300 text-ivory-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logoUrl} alt="Sunshine Real Estate" className="w-12 h-12 object-contain" />
              <div>
                <div className="text-base font-bold text-white leading-tight">Sunshine Real Estate</div>
                <div className="text-xs text-ivory-200">Marketing SMC (Pvt.) Ltd.</div>
              </div>
            </div>
            <p className="text-sm text-ivory-300 leading-relaxed mb-5">
              Pakistan\'s trusted real estate investment partner. Verified projects, expert guidance, and transparent processes since 2019.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange text-white hover:text-white transition-all duration-300">
                <i className="ri-facebook-fill" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange text-white hover:text-white transition-all duration-300">
                <i className="ri-instagram-line" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange text-white hover:text-white transition-all duration-300">
                <i className="ri-linkedin-fill" />
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-green text-white hover:text-white transition-all duration-300">
                <i className="ri-whatsapp-line" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <a
                    href={link.path}
                    onClick={(e) => { e.preventDefault(); handleClick(link.path); }}
                    className="text-sm text-ivory-200 hover:text-brand-orange transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="/#services" onClick={(e) => { e.preventDefault(); handleClick('/'); setTimeout(() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="text-sm text-ivory-200 hover:text-brand-orange transition-colors duration-300">
                  Services
                </a>
              </li>
            </ul>
          </div>

          {/* Projects */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Featured Projects</h4>
            <ul className="flex flex-col gap-2.5">
              {projectLinks.map((link) => (
                <li key={link.path}>
                  <a
                    href={link.path}
                    onClick={(e) => { e.preventDefault(); handleClick(link.path); }}
                    className="text-sm text-ivory-200 hover:text-brand-orange transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/projects"
                  onClick={(e) => { e.preventDefault(); handleClick('/projects'); }}
                  className="text-sm text-brand-orange hover:text-brand-orangeLight transition-colors duration-300 font-medium"
                >
                  View All Projects &rarr;
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Get In Touch</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a href={PHONE_URL} className="flex items-center gap-3 text-sm text-ivory-200 hover:text-brand-orange transition-colors">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10">
                    <i className="ri-phone-line text-brand-orange" />
                  </span>
                  +92 334 8872555
                </a>
              </li>
              <li>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-ivory-200 hover:text-brand-green transition-colors">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10">
                    <i className="ri-whatsapp-line text-brand-green" />
                  </span>
                  WhatsApp Us
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-sm text-ivory-200">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 shrink-0">
                    <i className="ri-map-pin-line text-brand-orange" />
                  </span>
                  Islamabad, Pakistan
                </div>
              </li>
              <li>
                <div className="flex items-center gap-3 text-sm text-ivory-200">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 shrink-0">
                    <i className="ri-time-line text-brand-orange" />
                  </span>
                  Mon – Sat: 9:00 AM – 7:00 PM
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-4 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-ivory-300 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Sunshine Real Estate Marketing SMC (Pvt.) Ltd. All rights reserved.
          </p>

          {/* Powered by attribution */}
          <div className="flex items-center gap-3">
            <span className="w-px h-4 bg-white/20" aria-hidden="true"></span>
            <span className="text-xs text-gray-400 whitespace-nowrap">
              Powered by{' '}
              <a
                href="https://wa.me/923122590119"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-orange hover:text-brand-orangeLight hover:underline transition-all duration-200"
              >
                Agency 360
              </a>
            </span>
            <span className="w-px h-4 bg-white/20" aria-hidden="true"></span>
          </div>

          <div className="flex items-center gap-4 text-xs text-ivory-300">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-brand-orange transition-colors">Privacy Policy</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-brand-orange transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}